import { Container } from '../../odie';

import {
  AndroidBlockProps,
  AnimalBlockProps,
  BasicBlockProps,
  blockPropsMap,
  BombBlockProps,
  ButterflyBlockProps,
  CageBlockProps,
  CandleBlockProps,
  CandyBagBlockProps,
  CandyBlockProps,
  ChainBlockProps,
  ChameleonBlockProps,
  CocoonBlockProps,
  CoffinBlockProps,
  ColorsBlockOptionDef,
  CountBlockOptionDef,
  CubeBlockProps,
  CurtainBlockProps,
  DirectionBlockOptionDef,
  PondBlockProps,
  DogBlockProps,
  DoorBlockProps,
  FireboxBlockProps,
  FuguBlockProps,
  FullIceBlockProps,
  HalfIceBlockProps,
  HatBlockProps,
  HazardBlockProps,
  IceBlockProps,
  KappaBlockProps,
  KettleBlockProps,
  LockBlockProps,
  MiniFuguBlockProps,
  PantherBlockProps,
  PipeBlockProps,
  NestBlockProps,
  RandomSpawnBlockProps,
  RocketBlockProps,
  ShellBlockProps,
  SirenBlockProps,
  SkullBlockProps,
  SlimeBlockProps,
  SpiderBlockProps,
  StatueBlockProps,
  ThickIceBlockProps,
  ThrowerBlockProps,
  VirusBlockProps,
  WormBlockProps,
  ZombieBlockProps,
  SodaBlockProps,
  MushroomBlockProps,
  ChocolateEggBlockProps,
  AlarmBlockProps,
  BubblesBlockProps,
  ColorBlockOptionDef,
  ParcelsBlockProps,
  WallBlockProps,
  FossilBlockProps,
  CornBlockProps,
  PopcornBlockProps,
  TunaCanBlockProps,
  TunaFishBlockProps,
  RainbowBubbleBlockProps,
  FirecrackerBoxBlockProps,
  CoolerBlockProps,
  TvBlockProps,
  ShieldBubbleBlockProps,
  BathtubBlockProps,
} from '../../game/defs/block';
import { BlockDef } from '../../game/defs/map';
import { AndroidBlockView } from '../../game/views/blocks/AndroidBlockView';
import { AnimalBlockView } from '../../game/views/blocks/AnimalBlockView';
import { BasicBlockView } from '../../game/views/blocks/BasicBlockView';
import { BombBlockView } from '../../game/views/blocks/BombBlockView';
import { CageBlockView } from '../../game/views/blocks/CageBlockView';
import { CandleBlockView } from '../../game/views/blocks/CandleBlockView';
import { ChainBlockView } from '../../game/views/blocks/ChainBlockView';
import { ChameleonBlockView } from '../../game/views/blocks/ChameleonBlockView';
import { CoffinBlockView } from '../../game/views/blocks/CoffinBlockView';
import { CubeBlockView } from '../../game/views/blocks/CubeBlockView';
import { DogBlockView } from '../../game/views/blocks/DogBlockView';
import { DoorBlockView } from '../../game/views/blocks/DoorBlockView';
import { FireboxBlockView } from '../../game/views/blocks/FireboxBlockView';
import { FuguBlockView } from '../../game/views/blocks/FuguBlockView';
import { HatBlockView } from '../../game/views/blocks/HatBlockView';
import { HazardBlockView } from '../../game/views/blocks/HazardBlockView';
import { KappaBlockView } from '../../game/views/blocks/KappaBlockView';
import { KettleBlockView } from '../../game/views/blocks/KettleBlockView';
import { LockBlockView } from '../../game/views/blocks/LockBlockView';
import { MiniFuguBlockView } from '../../game/views/blocks/MiniFuguBlockView';
import { PantherBlockView } from '../../game/views/blocks/PantherBlockView';
import { PipeBlockView } from '../../game/views/blocks/PipeBlockView';
import { NestBlockView } from '../../game/views/blocks/NestBlockView';
import { RocketBlockView } from '../../game/views/blocks/RocketBlockView';
import {
  SirenBlockView,
  SirenKey,
} from '../../game/views/blocks/SirenBlockView';
import { SkullBlockView } from '../../game/views/blocks/SkullBlockView';
import { SlimeBlockView } from '../../game/views/blocks/SlimeBlockView';
import { SpiderBlockView } from '../../game/views/blocks/SpiderBlockView';
import { StatueBlockView } from '../../game/views/blocks/StatueBlockView';
import { ThrowerBlockView } from '../../game/views/blocks/ThrowerBlockView';
import { VirusBlockView } from '../../game/views/blocks/VirusBlockView';
import { ThickIceBlockView } from '../../game/views/blocks/ThickIceBlockView';
import { HalfIceBlockView } from '../../game/views/blocks/HalfIceBlockView';
import { FullIceBlockView } from '../../game/views/blocks/FullIceBlockView';
import { RandomSpawnBlockView } from '../../game/views/blocks/RandomSpawnBlockView';
import { ZombieBlockView } from '../../game/views/blocks/ZombieBlockView';
import { WormBlockView } from '../../game/views/blocks/WormBlockView';
import { CocoonBlockView } from '../../game/views/blocks/CocoonBlockView';
import { ButterflyBlockView } from '../../game/views/blocks/ButterflyBlockView';
import { CurtainBlockView } from '../../game/views/blocks/CurtainBlockView';
import { ShellBlockView } from '../../game/views/blocks/ShellBlockView';
import { PondBlockView } from '../../game/views/blocks/PondBlockView';
import { CandyBagBlockView } from '../../game/views/blocks/CandyBagBlockView';
import { CandyBlockView } from '../../game/views/blocks/CandyBlockView';
import { SodaBlockView } from '../../game/views/blocks/SodaBlockView';
import { MushroomBlockView } from '../../game/views/blocks/MushroomBlockView';
import { ChocolateEggBlockView } from '../../game/views/blocks/ChocolateEggBlockView';
import { AlarmBlockView } from '../../game/views/blocks/AlarmBlockView';
import { BubblesBlockView } from '../../game/views/blocks/BubblesBlockView';
import { ParcelsBlockView } from '../../game/views/blocks/ParcelsBlockView';
import { WallBlockView } from '../../game/views/blocks/WallBlockView';
import { FossilBlockView } from '../../game/views/blocks/FossilBlockView';
import { CornBlockView } from '../../game/views/blocks/CornBlockView';
import { PopcornBlockView } from '../../game/views/blocks/PopcornBlockView';
import { TunaCanBlockView } from '../../game/views/blocks/TunaCanBlockView';
import { TunaFishBlockView } from '../../game/views/blocks/TunaFishBlockView';
import { RainbowBubbleBlockView } from '../../game/views/blocks/RainbowBubbleBlockView';
import { CoolerBlockView } from '../../game/views/blocks/CoolerBlockView';
import { TvBlockView } from '../../game/views/blocks/TvBlockView';
import { ShieldBubbleBlockView } from '../../game/views/blocks/ShieldBubbleBlockView';
import { BathtubBlockView } from '../../game/views/blocks/BathtubBlockView';
import { assertNever } from 'src/replicant/utils';
import {
  blockOptionFromCountColor,
  blockOptionFromCountSize,
  blockOptionToCountColor,
  blockOptionToCountSize,
} from '../../game/util/blockOption';
import { FirecrackerBoxBlockView } from '../../game/views/blocks/FirecrackerBoxBlockView';
import { _createSharpenerBlockView } from '../../game/blocks/sharpener/SharpenerBlockView';
import { _createBarrelBlockView } from '../../game/blocks/barrel/BarrelBlockView';
import { _createRainbowSoapBlockView } from '../../game/blocks/rainbowSoap/RainbowSoapBlockView';
import { _createBigEggBlockView } from '../../game/blocks/bigEgg/BigEggBlockView';
import { _createPiggyBankBlockView } from '../../game/blocks/piggyBank/PiggyBankBlockView';
import { _createBalloonBoxBlockView } from '../../game/blocks/balloonBox/BalloonBoxBlockView';
import { _createOctopusBlockView } from '../../game/blocks/octopus/OctopusBlockView';
import { _createFlowerFidgetBlockView } from '../../game/blocks/flowerFidget/FlowerFidgetBlockView';
import { _createGrassBlockView } from '../../game/blocks/grass/GrassBlockView';
import { _createMagicBunniesBlockView } from '../../game/blocks/magicBunnies/MagicBunniesBlockView';
import features from 'src/replicant/ruleset/features';
import { user } from 'src/StateObserver';
import { CrateBlockView } from '../../game/blocks/crate/CrateBlockView';
import { _createLaserBoxBlockView } from '../../game/blocks/laserBox/LaserBoxBlockView';

// api
//-----------------------------------------------------------------------------
export function createBlockView(blockDef: BlockDef): Container {
  const props = blockPropsMap[blockDef.id];
  const option = blockDef.option || 0;

  switch (props.type) {
    case 'android':
      return _createAndroidBlockView(props, option);
    case 'animal':
      return _createAnimalBlockView(props);
    case 'basic':
      return _createBasicBlockView(props);
    case 'bomb':
      return _createBombBlockView(props);
    case 'cage':
      return _createCageBlockView(props);
    case 'candle':
      return _createCandleBlockView(props, option);
    case 'chain':
      return _createChainBlockView(props, option);
    case 'chameleon':
      return _createChameleonBlockView(props, option);
    case 'coffin':
      return _createCoffinBlockView(props);
    case 'cube':
      return _createCubeBlockView(props);
    case 'dog':
      return _createDogBlockView(props, option);
    case 'door':
      return _createDoorBlockView(props, option);
    case 'firebox':
      return _createFireboxBlockView(props, option);
    case 'hat':
      return _createHatBlockView(props);
    case 'hazard':
      return _createHazardBlockView(props);
    case 'kappa':
      return _createKappaBlockView(props, option);
    case 'kettle':
      return _createKettleBlockView(props);
    case 'lock':
      return _createLockBlockView(props, option);
    case 'miniFugu':
      return _createMiniFuguBlockView(props);
    case 'panther':
      return _createPantherBlockView(props);
    case 'pipe':
      return _createPipeBlockView(props);
    case 'randomSpawn':
      return _createRandomSpawnBlockView(props);
    case 'rocket':
      return _createRocketBlockView(props);
    case 'siren':
      return _createSirenBlockView(props, option);
    case 'skull':
      return _createSkullBlockView(props, option);
    case 'slime':
      return _createSlimeBlockView(props);
    case 'spider':
      return _createSpiderBlockView(props);
    case 'fugu':
      return _createFuguBlockView(props);
    case 'statue':
      return _createStatueBlockView(props, option);
    case 'thrower':
      return _createThrowerBlockView(props);
    case 'virus':
      return _createVirusBlockView(props);
    case 'ice':
      return _createIceBlockView(props);
    case 'thickIce':
      return _createThickIceBlockView(props);
    case 'fullIce':
      return _createFullIceBlockView(props);
    case 'halfIce':
      return _createHalfIceBlockView(props);
    case 'zombie':
      return _createZombieBlockView(props);
    case 'worm':
      return _createWormBlockView(props);
    case 'cocoon':
      return _createCocoonBlockView(props);
    case 'butterfly':
      return _createButterflyBlockView(props);
    case 'curtain':
      return _createCurtainBlockView(props, option);
    case 'pond':
      return _createPondBlockView(props, option);
    case 'candyBag':
      return _createCandyBagBlockView(props);
    case 'candy':
      return _createCandyBlockView(props);
    case 'shell':
      return _createShellBlockView(props, option);
    case 'soda':
      return _createSodaBlockView(props, option);
    case 'bubbles':
      return _createBubblesBlockView(props);
    case 'alarm':
      return _createAlarmBlockView(props, option);
    case 'chocolateEgg':
      return _createChocolateEggBlockView(props, option);
    case 'nest':
      return _createNestBlockView(props);
    case 'mushroom':
      return _createMushroomBlockView(props);
    case 'parcels':
      return _createParcelsBlockView(props);
    case 'wall':
      return _createWallBlockView(props);
    case 'fossil':
      return _createFossilBlockView(props, option);
    case 'corn':
      return _createCornBlockView(props);
    case 'popcorn':
      return _createPopcornBlockView(props);
    case 'tunaCan':
      return _createTunaCanBlockView(props);
    case 'tunaFish':
      return _createTunaFishBlockView(props);
    case 'rainbowBubble':
      return _createRainbowBubbleBlockView(props);
    case 'firecrackerBox':
      return _createFirecrackerBoxBlockView(props, option);
    case 'cooler':
      return _createCoolerBlockView(props, option);
    case 'tv':
      return _createTvBlockView(props);
    case 'shieldBubble':
      return _createShieldBubbleBlockView(props);
    case 'bathtub':
      return _createBathtubBlockView(props, option);
    case 'sharpener':
      return _createSharpenerBlockView(props, option);
    case 'barrel':
      return _createBarrelBlockView(props, option);
    case 'rainbowSoap':
      return _createRainbowSoapBlockView(props);
    case 'bigEgg':
      return _createBigEggBlockView(props, option);
    case 'piggyBank':
      return _createPiggyBankBlockView(props, option);
    case 'balloonBox':
      return _createBalloonBoxBlockView(props, option);
    case 'octopus':
      return _createOctopusBlockView(props);
    case 'flowerFidget':
      return _createFlowerFidgetBlockView(props);
    case 'grass':
      return _createGrassBlockView(props, option);
    case 'magicBunnies':
      return _createMagicBunniesBlockView(props, option);
    case 'laserBox':
      return _createLaserBoxBlockView(props, option);
    default:
      assertNever(props);
  }
}

// private: builders
//-----------------------------------------------------------------------------
export function _createAndroidBlockView(
  props: AndroidBlockProps,
  option: number,
): AndroidBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new AndroidBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createAnimalBlockView(
  props: AnimalBlockProps,
): AnimalBlockView {
  return new AnimalBlockView(props);
}

export function _createBasicBlockView(props: BasicBlockProps): BasicBlockView {
  return new BasicBlockView(props);
}

export function _createBombBlockView(props: BombBlockProps): BombBlockView {
  return new BombBlockView(props);
}

export function _createCageBlockView(props: CageBlockProps): CageBlockView {
  return new CageBlockView(props);
}

export function _createCandleBlockView(
  props: CandleBlockProps,
  option: number,
): CandleBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new CandleBlockView(props);
  view.count = optionDef.count;
  return view;
}

export function _createChainBlockView(
  props: ChainBlockProps,
  option: number,
): ChainBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new ChainBlockView(props);
  view.damage = optionDef.count;
  return view;
}

export function _createChameleonBlockView(
  props: ChameleonBlockProps,
  option: number,
): ChameleonBlockView {
  const optionDef = props.options![option] as ColorBlockOptionDef;
  const view = new ChameleonBlockView(props);
  view.color = optionDef.color;
  return view;
}

export function _createCoffinBlockView(
  props: CoffinBlockProps,
): CoffinBlockView {
  return new CoffinBlockView(props);
}

export function _createCubeBlockView(props: CubeBlockProps): CubeBlockView {
  return new CubeBlockView(props);
}

export function _createDogBlockView(
  props: DogBlockProps,
  option: number,
): DogBlockView {
  const optionDef = props.options![option] as DirectionBlockOptionDef;
  const view = new DogBlockView(props);
  view.direction = optionDef.direction;
  return view;
}

export function _createDoorBlockView(
  props: DoorBlockProps,
  option: number,
): DoorBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new DoorBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createFireboxBlockView(
  props: FireboxBlockProps,
  option: number,
): FireboxBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new FireboxBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createHatBlockView(props: HatBlockProps): HatBlockView {
  if (features(user()).newFirst2ObstacleVisuals && props.color === 'all') {
    return new CrateBlockView(props);
  }

  return new HatBlockView(props);
}

export function _createHazardBlockView(
  props: HazardBlockProps,
): HazardBlockView {
  return new HazardBlockView(props);
}

export function _createKettleBlockView(
  props: KettleBlockProps,
): KettleBlockView {
  return new KettleBlockView(props);
}

export function _createLockBlockView(
  props: LockBlockProps,
  option: number,
): LockBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new LockBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createMiniFuguBlockView(
  props: MiniFuguBlockProps,
): MiniFuguBlockView {
  return new MiniFuguBlockView(props);
}

export function _createPantherBlockView(
  props: PantherBlockProps,
): PantherBlockView {
  return new PantherBlockView(props);
}

export function _createPipeBlockView(props: PipeBlockProps): PipeBlockView {
  return new PipeBlockView(props);
}

export function _createRandomSpawnBlockView(
  props: RandomSpawnBlockProps,
): RandomSpawnBlockView {
  return new RandomSpawnBlockView(props);
}

export function _createRocketBlockView(
  props: RocketBlockProps,
): RocketBlockView {
  return new RocketBlockView(props);
}

export function _createSirenBlockView(
  props: SirenBlockProps,
  option: number,
): SirenBlockView {
  const optionDef = props.options![option] as ColorsBlockOptionDef;
  const view = new SirenBlockView(props);

  for (let i = 0; i < optionDef.colors.length; i++) {
    const color = optionDef.colors[i];
    view.enable(i as SirenKey, color);
  }

  return view;
}

export function _createSkullBlockView(
  props: SkullBlockProps,
  option: number,
): SkullBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new SkullBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createFuguBlockView(props: FuguBlockProps): FuguBlockView {
  return new FuguBlockView(props);
}

export function _createKappaBlockView(
  props: KappaBlockProps,
  option: number,
): KappaBlockView {
  const view = new KappaBlockView(props);
  view.setOption(option);
  return view;
}

export function _createSlimeBlockView(props: SlimeBlockProps): SlimeBlockView {
  return new SlimeBlockView(props);
}

export function _createSpiderBlockView(
  props: SpiderBlockProps,
): SpiderBlockView {
  return new SpiderBlockView(props);
}

export function _createStatueBlockView(
  props: StatueBlockProps,
  option: number,
): StatueBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new StatueBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createThrowerBlockView(
  props: ThrowerBlockProps,
): ThrowerBlockView {
  const view = new ThrowerBlockView(props);
  return view;
}

export function _createVirusBlockView(props: VirusBlockProps): VirusBlockView {
  return new VirusBlockView(props);
}

export function _createIceBlockView(props: IceBlockProps): FullIceBlockView {
  return new FullIceBlockView(props);
}

export function _createThickIceBlockView(
  props: ThickIceBlockProps,
): ThickIceBlockView {
  return new ThickIceBlockView(props);
}

export function _createHalfIceBlockView(
  props: HalfIceBlockProps,
): HalfIceBlockView {
  return new HalfIceBlockView(props);
}

export function _createFullIceBlockView(
  props: FullIceBlockProps,
): FullIceBlockView {
  return new FullIceBlockView(props);
}

export function _createZombieBlockView(
  props: ZombieBlockProps,
): ZombieBlockView {
  return new ZombieBlockView(props);
}

export function _createWormBlockView(props: WormBlockProps): WormBlockView {
  return new WormBlockView(props);
}

export function _createCocoonBlockView(
  props: CocoonBlockProps,
): CocoonBlockView {
  return new CocoonBlockView(props);
}

export function _createButterflyBlockView(
  props: ButterflyBlockProps,
): ButterflyBlockView {
  return new ButterflyBlockView(props);
}

export function _createCurtainBlockView(
  props: CurtainBlockProps,
  option: number,
): CurtainBlockView {
  if (!option) {
    option = blockOptionFromCountSize({
      count: props.count,
      width: props.width,
      height: props.height,
    });
  }

  const countSize = blockOptionToCountSize(option);
  return new CurtainBlockView({ ...props, ...countSize });
}

export function _createShellBlockView(
  props: ShellBlockProps,
  option: number,
): ShellBlockView {
  const block = new ShellBlockView(props);

  block.open = !!option;

  return block;
}

export function _createPondBlockView(
  props: PondBlockProps,
  option: number,
): PondBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new PondBlockView(props);
  view.damage = optionDef.count;
  return view;
}

export function _createCandyBagBlockView(
  props: CandyBagBlockProps,
): CandyBagBlockView {
  return new CandyBagBlockView(props);
}

export function _createCandyBlockView(props: CandyBlockProps): CandyBlockView {
  return new CandyBlockView(props);
}

export function _createSodaBlockView(
  props: SodaBlockProps,
  option: number,
): SodaBlockView {
  const optionDef = props.options![option];
  return new SodaBlockView({ ...props, ...optionDef });
}

export function _createBubblesBlockView(
  props: BubblesBlockProps,
): BubblesBlockView {
  return new BubblesBlockView(props);
}

export function _createAlarmBlockView(
  props: AlarmBlockProps,
  option: number,
): AlarmBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new AlarmBlockView(props);

  view.count = optionDef.count;

  return view;
}

export function _createChocolateEggBlockView(
  props: ChocolateEggBlockProps,
  option: number,
): ChocolateEggBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new ChocolateEggBlockView(props);
  view.count = optionDef.count;
  return view;
}

export function _createNestBlockView(props: NestBlockProps): NestBlockView {
  return new NestBlockView(props);
}

export function _createMushroomBlockView(
  props: MushroomBlockProps,
): MushroomBlockView {
  return new MushroomBlockView(props);
}

export function _createWallBlockView(props: WallBlockProps): WallBlockView {
  return new WallBlockView(props);
}

export function _createParcelsBlockView(
  props: ParcelsBlockProps,
): ParcelsBlockView {
  const view = new ParcelsBlockView(props);
  return view;
}

export function _createFossilBlockView(
  props: FossilBlockProps,
  option: number,
): FossilBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new FossilBlockView(props);
  view.count = optionDef.count;
  return view;
}

export function _createCornBlockView(props: CornBlockProps): CornBlockView {
  return new CornBlockView(props);
}

export function _createPopcornBlockView(
  props: PopcornBlockProps,
): PopcornBlockView {
  return new PopcornBlockView(props);
}

export function _createTunaCanBlockView(
  props: TunaCanBlockProps,
): TunaCanBlockView {
  return new TunaCanBlockView(props);
}

export function _createTunaFishBlockView(
  props: TunaFishBlockProps,
): TunaFishBlockView {
  return new TunaFishBlockView(props);
}

export function _createRainbowBubbleBlockView(props: RainbowBubbleBlockProps) {
  return new RainbowBubbleBlockView(props);
}

export function _createFirecrackerBoxBlockView(
  props: FirecrackerBoxBlockProps,
  option: number,
) {
  if (!option) {
    option = blockOptionFromCountColor({
      count: props.count,
      color: props.color,
    });
  }

  const countColor = blockOptionToCountColor(option);
  return new FirecrackerBoxBlockView({ ...props, ...countColor });
}

export function _createCoolerBlockView(
  props: CoolerBlockProps,
  option: number,
): CoolerBlockView {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new CoolerBlockView(props);
  view.count = optionDef.count;
  return view;
}

export function _createTvBlockView(props: TvBlockProps): TvBlockView {
  return new TvBlockView(props);
}

export function _createShieldBubbleBlockView(props: ShieldBubbleBlockProps) {
  return new ShieldBubbleBlockView(props);
}

export function _createBathtubBlockView(
  props: BathtubBlockProps,
  option: number,
) {
  const optionDef = props.options![option] as CountBlockOptionDef;
  const view = new BathtubBlockView(props);

  view.count = optionDef.count;

  return view;
}
